export default {
	methods: {
        redirectTo(ctaButton) {
            switch(ctaButton.actionType) {
                case 'ALL_CONVERSATIONS': 
                    this.screenType = "conversation_list"
                break;
                case 'ALL_ORDERS': 
                    if(this.isUserLoggedIn()) {
                        this.OpenAllPreviousOrders()
                    } else {
                        this.screenType = 'LOGIN_SCREEN'
                        this.afterLoginRedirectTo = ctaButton
                    }
                break;

                case 'MESSENGER': 
                    this.screenType = "start"
                break;

                case 'LOGIN': 
                    this.screenType = "LOGIN_SCREEN"
                break;

                case 'HELPCENTER': 
                    this.screenType = "help-and-support"
                    let scenarios = this.scenarioList[ctaButton.blockType]
                    if(this.isUserLoggedIn() || ctaButton.blockType === 'HELPANDSUPPORT') {
                        let scenarioData = this.findScenario(scenarios, ctaButton.scenarioId, []) || {}
                        const { scenario , path = [] } = scenarioData
                        this.breadCrumbHandler = this.setBreadCrumbHandler(this.breadCrumbHandler, path, ctaButton.blockType)
                        if(scenario) {
                            this.onChildClick(scenario) 
                        } else {
                            this.handleNewConversationButtonClickFromRecent()
                        }
                    } else {
                        this.screenType = 'LOGIN_SCREEN'
                        this.afterLoginRedirectTo = ctaButton
                    }
                break;

                default : 
                    let url = ctaButton.buttonUrl
                    window.open(url, "_blank");
                break;
            }
        },
        findScenario(scenarioList, id, pPath, scenario) {
            let path = JSON.parse(JSON.stringify(pPath))
            if(scenario) {
                path.push(scenario)
            }
            for(let index = 0; index < scenarioList.length; index++) {
                let scenario = scenarioList[index]
                if (id === scenario.scenarioId){
                    return {
                        path, 
                        scenario
                    }
                } else if(scenario.children && scenario.children.length) {
                    let data = this.findScenario(scenario.children, id, path, scenario)
                    if(data) {
                        return data
                    }
                } 
            }
        },
        setBreadCrumbHandler(oldPath, path, blockType) {
            let breadCrumb = []
            let flag = true
            if(blockType === 'ORDER') {
                oldPath.map(b => {
                    if(flag) {
                        breadCrumb.push(b)
                    }
                    if(b.scenarioId === "HELP_AND_SUPPORT_ORDER" || b.scenarioId === "HELP_AND_SUPPORT") {
                        flag = false
                    }
                    
                })
            } else {
                breadCrumb = [
                    {
                        children:[],
                        scenarioId:"HOME",
                        scenarioName:"Home"
                    },
                    {
                        children:[],
                        scenarioId:"HELP_AND_SUPPORT",
                        scenarioName:"Get help"
                    },

                ]
            }
            return breadCrumb.concat(path)
        },
        getAllScenariosId(list) {
            let ids = []
            list.map(l => {
                ids.push(l.scenarioId)
                if(l.children && l.children.length) {
                    ids = [ ... ids, ...this.getAllScenariosId(l.children) ]
                }
            })
            return ids
        }

    }
}